module.exports = __webpack_public_path__ + "img/auctionsplus.0c4ec2cb389bbeeddf96bc28135bcc3c.svg";